import React from "react";
import LogoView from "components/DataDisplay/LogoView";
import PlanDetails from "./PaymentPlanCard/parts/PlanDetails";
import EarlyOptions from "./PaymentPlanCard/parts/EarlyOptions";
import { getPlanDetailRows, getEarlyOwnershipOptions } from "../helpers";

const PlanDetailsPanel = ({ offer, cartTotal }) => {
  const rows = getPlanDetailRows(offer, cartTotal);
  const earlyOptions = getEarlyOwnershipOptions(offer);

  return (
    <div className="plan-details-panel">
      <div className="plan-details-panel__head">
        <span className="plan-details-panel__logo">
          <LogoView provider={offer.specific_provider_name} />
        </span>
        <span className="plan-details-panel__title">plan terms</span>
      </div>
      <PlanDetails rows={rows} />
      {earlyOptions.length > 0 && <EarlyOptions options={earlyOptions} />}
    </div>
  );
};

export default PlanDetailsPanel;
